// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CI/CD Integration Modal Styles */
.cicd-modal-container {
  width: 700px;
  max-width: 95vw;
  max-height: 90vh;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cicd-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eaeaea;
  background-color: #f9fafb;
}

.cicd-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.cicd-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.cicd-modal-close:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.cicd-modal-body {
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
  width: 100%;
}

.cicd-steps-container {
  display: flex;
  border-bottom: 1px solid #eaeaea;
  background-color: #f9fafb;
}

.cicd-step {
  flex: 1 1;
  padding: 16px 8px;
  text-align: center;
  position: relative;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
}

.cicd-step.active {
  color: #2563eb;
}

.cicd-step.completed {
  color: #10b981;
}

.cicd-step::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: transparent;
}

.cicd-step.active::after {
  background-color: #2563eb;
}

.cicd-step.completed::after {
  background-color: #10b981;
}

.cicd-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e5e7eb;
  color: #6b7280;
  margin-right: 8px;
  font-size: 0.875rem;
}

.cicd-step.active .cicd-step-number {
  background-color: #2563eb;
  color: white;
}

.cicd-step.completed .cicd-step-number {
  background-color: #10b981;
  color: white;
}

.cicd-content {
  padding: 24px;
  width: 100%;
}

/* Framework Selection */
.framework-selection {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.framework-option {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: white;
}

.framework-option:hover {
  border-color: #2563eb;
  background-color: #f9fafb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.framework-option.selected {
  border-color: #2563eb;
  background-color: #eff6ff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
}

.framework-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background-color: #f3f4f6;
  flex-shrink: 0;
}

.framework-option.selected .framework-icon {
  background-color: #dbeafe;
}

.framework-info {
  flex: 1 1;
}

.framework-info h4 {
  margin: 0 0 8px 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
}

.framework-info p {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.4;
}

/* Test Suite Selection */
.test-suite-selection {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  width: 100%;
}

.selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.selection-header label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #374151;
}

.selection-header span {
  font-size: 0.875rem;
  color: #6b7280;
  background-color: #e5e7eb;
  padding: 4px 8px;
  border-radius: 20px;
}

.test-suites-list {
  max-height: 240px;
  overflow-y: auto;
  padding: 8px 0;
  width: 100%;
}

.test-suite-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;
  width: 100%;
}

.test-suite-item:hover {
  background-color: #f9fafb;
}

.test-suite-item:last-child {
  border-bottom: none;
}

.test-suite-item label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-weight: 500;
  color: #374151;
  flex: 1 1;
}

.test-suite-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  cursor: pointer;
}

.test-case-count {
  font-size: 0.75rem;
  color: #6b7280;
  background-color: #f3f4f6;
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 8px;
}

/* CI/CD Configuration */
.cicd-config-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background-color: white;
}

.form-group input[type="text"]:focus,
.form-group input[type="number"]:focus,
.form-group select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-group input[type="text"]::placeholder {
  color: #9ca3af;
}

.checkbox-group {
  display: flex;
  align-items: start;
  gap: 8px;
  margin-bottom: 12px;
}

.checkbox-group label {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  cursor: pointer;
}

/* Advanced Options */
.advanced-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-bottom: 16px;
  transition: background-color 0.2s ease;
}

.advanced-toggle:hover {
  background-color: #f3f4f6;
}

.advanced-toggle h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
}

.advanced-toggle span {
  color: #6b7280;
  font-size: 1rem;
}

.advanced-options {
  margin-top: 16px;
  padding: 20px;
  background-color: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

/* Footer */
.cicd-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #eaeaea;
  background-color: #f9fafb;
}

.footer-buttons {
  display: flex;
  gap: 12px;
}

.back-button,
.cancel-button {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-button:hover,
.cancel-button:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.next-button,
.submit-button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.next-button:hover,
.submit-button:hover {
  background-color: #1d4ed8;
}

.next-button:disabled,
.submit-button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}

/* Step Content */
.step-content {
  display: none;
  width: 100%;
}

.step-content.active {
  display: block;
  width: 100%;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cicd-modal-container {
  animation: fadeIn 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/styles/cicd-integration.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* CI/CD Integration Modal Styles */\n.cicd-modal-container {\n  width: 700px;\n  max-width: 95vw;\n  max-height: 90vh;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cicd-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eaeaea;\n  background-color: #f9fafb;\n}\n\n.cicd-modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.cicd-modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #6b7280;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.cicd-modal-close:hover {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\n.cicd-modal-body {\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n  width: 100%;\n}\n\n.cicd-steps-container {\n  display: flex;\n  border-bottom: 1px solid #eaeaea;\n  background-color: #f9fafb;\n}\n\n.cicd-step {\n  flex: 1;\n  padding: 16px 8px;\n  text-align: center;\n  position: relative;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.cicd-step.active {\n  color: #2563eb;\n}\n\n.cicd-step.completed {\n  color: #10b981;\n}\n\n.cicd-step::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: transparent;\n}\n\n.cicd-step.active::after {\n  background-color: #2563eb;\n}\n\n.cicd-step.completed::after {\n  background-color: #10b981;\n}\n\n.cicd-step-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #e5e7eb;\n  color: #6b7280;\n  margin-right: 8px;\n  font-size: 0.875rem;\n}\n\n.cicd-step.active .cicd-step-number {\n  background-color: #2563eb;\n  color: white;\n}\n\n.cicd-step.completed .cicd-step-number {\n  background-color: #10b981;\n  color: white;\n}\n\n.cicd-content {\n  padding: 24px;\n  width: 100%;\n}\n\n/* Framework Selection */\n.framework-selection {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.framework-option {\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background-color: white;\n}\n\n.framework-option:hover {\n  border-color: #2563eb;\n  background-color: #f9fafb;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.framework-option.selected {\n  border-color: #2563eb;\n  background-color: #eff6ff;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);\n}\n\n.framework-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  background-color: #f3f4f6;\n  flex-shrink: 0;\n}\n\n.framework-option.selected .framework-icon {\n  background-color: #dbeafe;\n}\n\n.framework-info {\n  flex: 1;\n}\n\n.framework-info h4 {\n  margin: 0 0 8px 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.framework-info p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n/* Test Suite Selection */\n.test-suite-selection {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.selection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background-color: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.selection-header label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #374151;\n}\n\n.selection-header span {\n  font-size: 0.875rem;\n  color: #6b7280;\n  background-color: #e5e7eb;\n  padding: 4px 8px;\n  border-radius: 20px;\n}\n\n.test-suites-list {\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 8px 0;\n  width: 100%;\n}\n\n.test-suite-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.2s ease;\n  width: 100%;\n}\n\n.test-suite-item:hover {\n  background-color: #f9fafb;\n}\n\n.test-suite-item:last-child {\n  border-bottom: none;\n}\n\n.test-suite-item label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #374151;\n  flex: 1;\n}\n\n.test-suite-item input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.test-case-count {\n  font-size: 0.75rem;\n  color: #6b7280;\n  background-color: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 20px;\n  font-weight: 500;\n  white-space: nowrap;\n  margin-left: 8px;\n}\n\n/* CI/CD Configuration */\n.cicd-config-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  background-color: white;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"number\"]:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-group input[type=\"text\"]::placeholder {\n  color: #9ca3af;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: start;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.checkbox-group label {\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Advanced Options */\n.advanced-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 12px 16px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  transition: background-color 0.2s ease;\n}\n\n.advanced-toggle:hover {\n  background-color: #f3f4f6;\n}\n\n.advanced-toggle h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.advanced-toggle span {\n  color: #6b7280;\n  font-size: 1rem;\n}\n\n.advanced-options {\n  margin-top: 16px;\n  padding: 20px;\n  background-color: #f9fafb;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n/* Footer */\n.cicd-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-top: 1px solid #eaeaea;\n  background-color: #f9fafb;\n}\n\n.footer-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.back-button,\n.cancel-button {\n  background-color: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.back-button:hover,\n.cancel-button:hover {\n  background-color: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.next-button,\n.submit-button {\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.next-button:hover,\n.submit-button:hover {\n  background-color: #1d4ed8;\n}\n\n.next-button:disabled,\n.submit-button:disabled {\n  background-color: #93c5fd;\n  cursor: not-allowed;\n}\n\n/* Step Content */\n.step-content {\n  display: none;\n  width: 100%;\n}\n\n.step-content.active {\n  display: block;\n  width: 100%;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.cicd-modal-container {\n  animation: fadeIn 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
